import { root } from './recent';

export const recent = {
  ...root,
};
